import {PurchaseVehicleType} from '@dms/api/finance';

import {createContext} from 'shared/web';

type SelectVehicleContextType = {
  isVehicleModalOpen: boolean;
  setCreateVehicleModalOpen: (isOpen: boolean, purchaseVehicleType: PurchaseVehicleType) => void;
  isSelectSaleVehicleOpen: boolean;
  setSelectSaleVehicleOpen: (isOpen: boolean) => void;
  purchaseVehicleType: PurchaseVehicleType;
};

export const [Provider, useSelectVehicleContext] = createContext<SelectVehicleContextType>();
